import { Stack, Typography } from "@mui/material";
import { useShow } from "@refinedev/core";
import { Show, TextFieldComponent as TextField } from "@refinedev/mui";

const formatDateTime = (value?: string | null) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString();
};

export const ChallengeShow = () => {
  const { query } = useShow({});
  const { data, isLoading } = query;

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          {"ID"}
        </Typography>
        <TextField value={record?.id} />

        <Typography variant="body1" fontWeight="bold">
          {"Name"}
        </Typography>
        <TextField value={record?.name} />

        <Typography variant="body1" fontWeight="bold">
          {"Type"}
        </Typography>
        <TextField value={record?.type} />

        <Typography variant="body1" fontWeight="bold">
          {"Action Key"}
        </Typography>
        <TextField value={record?.actionKey} />

        <Typography variant="body1" fontWeight="bold">
          {"Target Count"}
        </Typography>
        <TextField value={record?.targetCount} />

        <Typography variant="body1" fontWeight="bold">
          {"Credit Reward"}
        </Typography>
        <TextField value={record?.creditReward} />

        <Typography variant="body1" fontWeight="bold">
          {"Active"}
        </Typography>
        <TextField value={record?.isActive ? "Yes" : "No"} />

        <Typography variant="body1" fontWeight="bold">
          {"Created At"}
        </Typography>
        <TextField value={formatDateTime(record?.createdAt)} />

        <Typography variant="body1" fontWeight="bold">
          {"Updated At"}
        </Typography>
        <TextField value={formatDateTime(record?.updatedAt)} />
      </Stack>
    </Show>
  );
};

